import { ActionCenterViewHandler } from '@/hooks/useActionCenterViewController';
import { ActionCenterItemV2 } from '@cloudcost/shared-types/action-center-v2';

interface AttestationHandlerOptions {
  setSelectedItemId: (id: string) => void;
  setIsDialogOpen: (open: boolean) => void;
  setFocusFilters: (filters: Record<string, string | undefined>) => void;
  focusOverviewTab: () => void;
}

function resolveAttestationFilters(
  item: ActionCenterItemV2,
): Record<string, string | undefined> {
  const filters: Record<string, string | undefined> = {};
  const scope = (item.scope || '').toString().trim().toLowerCase();

  const ownerId =
    item.owner_id ??
    (item as any).id_techowner ??
    (item as any).responsible_id ??
    null;
  if (ownerId && scope === 'owner') {
    filters.resourceOwner = String(ownerId);
  }

  if (item.department_id) {
    filters.department = String(item.department_id);
  }

  if (item.system_id) {
    filters.system = String(item.system_id);
  }

  const cloudAccountId =
    item.cloud_account_id ?? (item as any).id_cloud_account ?? null;
  if (cloudAccountId) {
    filters.cloudAccount = String(cloudAccountId);
  }

  return filters;
}

/**
 * Ensures Attestation tab focuses filters/dialog when an Action Center item is
 * selected via the shared controller.
 */
export function createAttestationActionCenterHandler({
  setSelectedItemId,
  setIsDialogOpen,
  setFocusFilters,
  focusOverviewTab,
}: AttestationHandlerOptions): ActionCenterViewHandler {
  return ({ item, clearSelection }) => {
    setSelectedItemId(String(item.id));
    setIsDialogOpen(true);
    focusOverviewTab();
    setFocusFilters(resolveAttestationFilters(item));
    clearSelection();
  };
}

